$(function(){
	gsap.registerPlugin(ScrollTrigger);
	let mm = gsap.matchMedia();
	
	const header = $('.hl-header');
		
  ScrollTrigger.create({
	trigger: ".hl-header-wrap",
	start: "bottom top",
	onEnterBack: () => header.removeClass('is-fixed'),
	onLeave: () => header.addClass('is-fixed'),
  });

	
	// 検索ボックスのアニメーション設定
	let isSearchOpen = false;
	
	$('.hl-header__btn--search, .hl-search__close').click(function(e) {
	  e.preventDefault();
	
	  if (!isSearchOpen) {
		gsap.fromTo(".hl-search", 
		  { display: "none", opacity: 0, y: -20 }, 
		  { display: "block", opacity: 1, y: 0, duration: 0.4, ease: "power2.out" }
		);
		isSearchOpen = true;
	  } else {
		gsap.to(".hl-search", {
		  opacity: 0,
		  y: -20,
		  duration: 0.3,
		  ease: "power2.in",
		  onComplete: () => gsap.set(".hl-search", { display: "none" })
		});
		isSearchOpen = false;
	  }
	});
	
	mm.add("(min-width: 769px)", () => {
		const balloonHeight = $('.hl-wrap__sub .hl-news-balloon').outerHeight() || 0;
		ScrollTrigger.create({
			trigger: ".hl-wrap__main",
			start: `top top-=${balloonHeight}`, 
			end: "bottom bottom",
			pin: ".hl-wrap__sub .hl-nav",
			pinSpacing: false,
			invalidateOnRefresh: true
		});
	});
	
	gsap.set(".hl-nav__drawer", {
		xPercent: -100,
		visibility: "visible"
	});
	
	$('.hl-nav__drawer__close').click(function(){
		gsap.to(".hl-nav__drawer", {
		  xPercent: -100,
		  duration: 0.4,
		  ease: "power2.inOut"
		});
		$('.hl-drawer__inner').removeClass('active');
	  });
	  
	$(document).on('click', function(e) {
	  if ($('.hl-nav__drawer').css('transform') !== 'none' && 
		  !$(e.target).closest('.hl-nav__drawer').length && 
		  !$(e.target).closest('.hl-nav__item--brand a').length) {
		
		gsap.to(".hl-nav__drawer", {
		  xPercent: -100,
		  duration: 0.4,
		  ease: "power2.inOut"
		});
	  }
	});
	
	$('.hl-nav__item--brand a').click(function(e){
		e.preventDefault();
		gsap.to(".hl-nav__drawer", {
			  xPercent: 0,
			  duration: 0.5,
			  ease: "power2.out"
		});
		$('.hl-drawer__inner').addClass('active');
	});
	
	$('.hl-header__btn--menu').click(function(e){
		e.preventDefault();
		gsap.to(".hl-drawer", {
			  xPercent: -100,
			  duration: 0.5,
			  ease: "power2.out"
		});
		$('.hl-bg,body').addClass('active');
	});
	
	$('.hl-bg').click(function(e){
		e.preventDefault();
		gsap.to(".hl-drawer", {
			  xPercent: 0,
			  duration: 0.5,
			  ease: "power2.out"
		});
		$('.hl-bg,body').removeClass('active');
	});
	
	function applySlickToRecommend($target) {
	  if ($target.hasClass('slick-initialized') || window.innerWidth > 768) return;
	  
	  if ($target.children().length === 0) return;
	
	  $target.slick({
		infinite: false,
		slidesToShow: 1.2,
		slidesToScroll: 1,
		speed: 600,
		dots: false,
		arrows: false
	  });
	}
	
	// GSAPのメディアクエリ監視
	mm.add("(max-width: 768px)", () => {
	  $('.hl-items--spslider').each(function() {
		applySlickToRecommend($(this));
	  });
	
	  return () => {
		$('.hl-items--spslider').each(function() {
		  if ($(this).hasClass('slick-initialized')) {
			$(this).slick('unslick');
		  }
		});
	  };
	});
	
	//ブログスライダー
	let $blogSlider = $('.hl-blogs--spslider');
	
	mm.add("(max-width: 768px)", () => {
	  $blogSlider.slick({
		infinite: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		centerMode: false,
		speed: 600,
		dots: false,
		arrows: false
	  });
	
	  return () => {
		if ($blogSlider.hasClass('slick-initialized')) {
		  $blogSlider.slick('unslick');
		}
	  };
	});
	
	//商品画像スライダー
	const $mainSlider = $('.hl-product__slider');
	const $thumbs = $('.hl-product__slider-thumb__item');
	
	$mainSlider.slick({
	slidesToShow: 1,
	slidesToScroll: 1,
	arrows: true,
	fade: true,
	infinite: true,
	adaptiveHeight: true,
	responsive: [
	  {
		breakpoint: 769,
		settings: {
		  arrows: false
		}
	  }
	]
	});
	
	$thumbs.on('click', function() {
	const index = $(this).index();
	$mainSlider.slick('slickGoTo', index);
	});
	
	$mainSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
	$thumbs.removeClass('active');
	$thumbs.eq(nextSlide).addClass('active');
	});
	
	$mainSlider.on('afterChange setPosition', function(event, slick) {
	  ScrollTrigger.refresh();
	});
	
	$thumbs.eq(0).addClass('active');
	
	mm.add("(min-width: 769px)", () => {
		
		
		var targetHeight = $('.hl-product__image__wrap').innerHeight();
		
		startHeight = 'top-=' + 60;
		endHeight = 'bottom-=' + (targetHeight + 60);
		gsap.to('.hl-product__image__wrap', {
		  scrollTrigger: {
			trigger: '.hl-product__image__wrap',
			start: startHeight,
			endTrigger: '.hl-product__text',
			end: endHeight,
			pin: true,
			markers: false
		  }
		});
	});
	
	mm.add("(min-width: 1025px)", () => {
		var targetHeight = $('.hl-article__image__item').innerHeight();
		
		startHeight = 'top-=' + 123;
		endHeight = 'bottom-=' + (targetHeight + 123);
		gsap.to('.hl-article__image__item', {
		  scrollTrigger: {
			trigger: '.hl-article__image__item',
			start: startHeight,
			endTrigger: '.hl-article__text',
			end: endHeight,
			pin: true,
			markers: false
		  }
		});
	});
	
	mm.add("(min-width: 769px)", () => {
		var targetHeight = $('.hl-column__sub__item').innerHeight();
		
		startHeight = 'top-=' + 123;
		endHeight = 'bottom-=' + (targetHeight + 123);
		gsap.to('.hl-column__sub__item', {
		  scrollTrigger: {
			trigger: '.hl-column__sub__item',
			start: startHeight,
			endTrigger: '.hl-column__main',
			end: endHeight,
			pin: true,
			markers: false
		  }
		});
	});
	
	document.querySelectorAll('a[href^="#"]').forEach(link => {
	  link.addEventListener("click", e => {
		e.preventDefault();
		const target = link.getAttribute("href");
	
		if (target === "#" || !document.querySelector(target)) return;
	
		let offsetValue = 0;
		if (window.innerWidth <= 768) {
		  offsetValue = 90; //
		}
	
		gsap.to(window, {
		  duration: 1,
		  scrollTo: {
			y: target,
			offsetY: offsetValue // これで指定したpx分だけ手前で止まります
		  },
		  ease: "power3.inOut"
		});
	  });
	});
});